// Maps django-apscheduler's raw DjangoJobExecution.status strings to i18n keys
// under the `cron` namespace `statuses.*`.
const STATUS_KEY: Record<string, string> = {
  'Started execution': 'started',
  Executed: 'executed',
  'Missed!': 'missed',
  'Max instances!': 'maxInstances',
  'Error!': 'error'
}

export function statusKey(status: string): string | undefined {
  return STATUS_KEY[status]
}
